<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="65%">
        <a-form layout="horizontal" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input v-model:value="form.id"/>
                </a-form-item>
            </div>
            <a-row :gutter="[24,8]">
                <a-col :span="24">
                    <a-form-item label="图片" name="icon">
                        <ImgUpload v-model:value="form.icon"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="商标名称" name="brandName">
                        <a-input v-model:value="form.brandName" placeholder="请输入商标名称"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="商标行业类型" name="brandIndustryType">
                        <DictSelect
                            v-model:value="form.brandIndustryType"
                            :dict-name="innovation.PROJECT_TYPE"
                            placeholder="请选择"
                        />
                    </a-form-item>
                </a-col>

                <a-col :span="12">
                    <a-form-item label="保护范围分析" name="rangeAnalysis">
                        <a-input v-model:value="form.rangeAnalysis"/>
                    </a-form-item>
                </a-col>

                <a-col :span="12">
                    <a-form-item label="注册公告期号" name="brandNumber">
                        <a-input v-model:value="form.brandNumber"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="商标持有人" name="brandHolder">
                        <a-input v-model:value="form.brandHolder"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="联系电话" name="linkPhone">
                        <a-input v-model:value="form.linkPhone"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="初审公告期号" name="firstCode">
                        <a-input v-model:value="form.firstCode"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="初审公告日期" name="firstTime">
                        <DatePicker v-model:value="form.firstTime" placeholder="请输入认定时间" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="注册公告日期" name="announcementTime">
                        <DatePicker v-model:value="form.announcementTime" placeholder="请输入认定时间" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="商标起始时间" name="startTime">
                        <DatePicker v-model:value="form.startTime" placeholder="请输入认定时间" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="品牌理念" name="description">
                        <TinymceEditor v-model:value="form.description"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="适用范围" name="scopeApplication">
                        <TinymceEditor v-model:value="form.scopeApplication"/>
                    </a-form-item>
                </a-col>
                <!--可编辑区域 end-->
            </a-row>
        </a-form>

    </a-modal>
</template>
<script>
    // import dataCheck from "@/utils/dataCheck";
    import {formMixin} from "@/mixins";
    import {brandApi} from "@/api/knowledge";
    import DictSelect from "@/components/other/DictSelect";
    import {innovation} from "@/config/variableConfig";
    import TinymceEditor from "@/components/form/editor/TinymceEditor";

    export default {
        name: "AddOrEditModal",
        components: {TinymceEditor, DictSelect},

        mixins: [formMixin],
        data() {
            return {
                innovation,
                form: {
                    id: null,
                    brandName: null,
                    brandIndustryType: null,
                    icon:null,
                    description: null,
                    scopeApplication: null,
                    brandNumber: null,
                    firstTime: null,
                    firstCode: null,
                    announcementTime: null,
                    brandHolder: null,
                    linkPhone: null,
                    startTime: null,
                    rangeAnalysis: null,

                },
                rules: {
                    id: [],
                    brandName: [],
                    brandIndustryType: [],
                    icon:null,
                    description: [],
                    scopeApplication: [],
                    brandNumber: [],
                    firstTime: [],
                    firstCode: [],
                    announcementTime: [],
                    brandHolder: [],
                    linkPhone: [],
                    startTime: [],
                    rangeAnalysis: [],
                },
                submitUrl: brandApi.saveOrUpdate
            }
        },
        mounted() {
        },
        methods: {},
    }
</script>
<style scoped lang="less">
</style>
